export const GET_RELEASES = "GET_RELEASES";
export const GET_RELEASE = "GET_RELEASE";
export const ADD_RELEASE = "ADD_RELEASE";
export const RELEASE_ERROR = "RELEASE_ERROR";
export const CLEAR_CURRENT = "CLEAR_CURRENT";
